import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const authModule = {
  namespaced: true,
  state: {
    token: localStorage.getItem("token"),
    expiresIn: parseInt(localStorage.getItem("expiresIn")) || 0,
    type: localStorage.getItem("type"),
  },
  mutations,
  actions,
  getters,
};

export default authModule;
